
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3335',
  depVersions: {
  "customer-portal-app": "static-1.3335",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.507",
  "data-fetching-client": "static-1.10079",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26434",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6028",
  "hs-test-utils": "static-1.8473",
  "hub-http": "static-1.6645",
  "hub-http-shared-msw-handlers": "static-1.10840",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19215",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11929",
  "I18n": "static-7.1700",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6886",
  "payment-link-components": "static-1.24376",
  "portals-platform-bend-plugin": "static-1.26",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7615",
  "quartz-core": "static-1.6834",
  "quartz-i18n": "static-1.1290",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10648",
  "react-dlb": "static-1.93",
  "react-utils": "static-2.5637",
  "reselect": "static-3.16",
  "rich-text-lib": "static-1.20494",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18526",
  "ui-components-test-utils": "static-1.6066",
  "UIComponents": "static-3.8875",
  "foundations-assets": "static-1.5322",
  "foundations-components": "static-1.8685",
  "foundations-theming": "static-1.4922",
  "foundations-theming-specialty": "static-1.2638",
  "framer-motion": "static-1.83",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1666",
  "quartz-config": "static-1.1393",
  "quartz-routing": "static-1.1045",
  "quick-fetch": "static-1.4206",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-use-beacon-keepalive-queue.3",
  "rpc-client-utils": "static-1.5108",
  "sanitize-text": "static-1.8592",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.65",
  "ui-addon-draggable": "static-3.5183",
  "ui-addon-react-router-dom": "static-1.9963",
  "usage-tracker": "static-1.7749",
  "usage-tracker-anonymous": "static-1.6166",
  "usage-tracker-core": "static-1.7599",
  "video-components-external": "static-1.12365",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3892",
  "quartz-webpack": "static-1.3839",
  "bend-plugin-quartz-routing": "static-1.693",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.93",
  "customer-data-objects": "static-1.8129",
  "frontend-preferences-client": "static-1.8355",
  "laboratory-lib": "static-3.7587",
  "onboarding-scopes": "static-1.6889",
  "seat-types-lib": "static-1.979",
  "ui-addon-opt": "static-4.8822",
  "HeadJS": "static-2.817",
  "hs-test-utils-bend-plugin": "static-1.3584",
  "msw": "static-1.102",
  "msw-config": "static-1.25",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.376",
  "ts-schema": "static-1.4376",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8366",
  "content-media-capture": "static-1.5717",
  "cssUtils": "static-1.1057",
  "customer-data-ui-utilities": "static-1.10269",
  "file-manager-components": "static-1.24773",
  "HubStyle": "static-2.12236",
  "knowledge-content-types": "static-1.8723",
  "PatternValidationJS": "static-1.3322",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.514",
  "ui-addon-emoji-picker": "static-1.10301",
  "ui-addon-i18n": "static-1.11581",
  "ui-business-units-lib": "static-1.9532",
  "ui-shepherd-react": "static-3.10712",
  "video-data-lib": "static-1.36023",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4744",
  "commerce-tours-lib": "static-1.6805",
  "customer-data-properties": "static-1.52942",
  "getting-started-shared-tasks": "static-1.19497",
  "growth-onboarding-reliability": "static-1.5518",
  "onboarding-tours": "static-1.17341",
  "reference-resolvers-lite": "static-1.8543",
  "sales-checkout-service-client": "static-1.3960",
  "ui-addon-iframeable": "static-1.9512",
  "user-context": "static-1.5490",
  "bender-build-tools": "static-1.3518",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.903",
  "hubspotter-http": "static-1.4950",
  "icons": "static-2.700",
  "mobile-manifest-mixins": "static-1.601",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.601",
  "quartz-auth": "static-1.1290",
  "quartz-head": "static-1.1280",
  "quartz-test": "static-1.1290",
  "quartz-tracking": "static-1.994",
  "trellis-components": "static-1.3020",
  "ui-fonts": "static-1.1191",
  "usage-tracker-container": "static-1.7739",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9861",
  "data-token-picker": "static-1.17071",
  "FileManagerLib": "static-1.40413",
  "property-translator": "static-1.5816",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6585",
  "SharedI18nStrings": "static-1.187",
  "foundations-components-test-utils": "static-1.6168",
  "react-create-root-preference": "static-1.97",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1270",
  "bend-plugin-foundations-components": "static-1.4954",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "trellis-assets": "static-1.3001",
  "bend-plugin-foundations-theming": "static-1.3405",
  "foundations-theming-base": "static-1.3907",
  "stylex": "static-1.46",
  "interframe": "static-3.5177",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6163",
  "opentelemetry-fe-types": "static-1.226",
  "beacon-keepalive-queue": "static-1.137",
  "web-vitals": "static-1.19",
  "bend-plugin-chirp-manifest": "static-1.518",
  "chirp-fetch": "static-1.2338",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4911",
  "react-flip-move": "static-1.82",
  "apollo-link-hub-http": "static-2.5023",
  "content-media-composition-data-lib": "static-1.13521",
  "content-media-compositions": "static-2.17528",
  "idb-keyval": "static-1.55",
  "immer": "static-1.105",
  "immerable": "static-1.4577",
  "magpie-lib": "static-1.5874",
  "magpie-types": "static-1.5334",
  "media-bridge-lib": "static-1.19586",
  "inbound-db-properties-service-client": "static-1.4126",
  "superstore": "static-1.5194",
  "feedback-loader": "static-1.30001",
  "ai-components-ui-library": "static-1.9953",
  "ui-addon-video-player": "static-1.9061",
  "ui-coaching-tips": "static-1.29536",
  "ContentUtils": "static-1.69391",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4863",
  "sassPrefix": "static-1.325",
  "react-dnd-compat": "static-1.5046",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2048",
  "copilot-toolkit": "static-1.12079",
  "poll-commands": "static-1.3911",
  "atom": "static-1.5513",
  "avatar-components": "static-1.2921",
  "navigation-messaging": "static-1.8420",
  "redux-thunk": "static-2.84",
  "reference-resolvers": "static-1.8616",
  "commerce-products-lib": "static-1.10807",
  "crm-message-bus": "static-1.44027",
  "growth-data-modal": "static-1.6077",
  "hubspot-apollo-client": "static-1.5315",
  "onboarding-tours-client": "static-1.5556",
  "batch-promise": "static-1.1984",
  "calling-global-api": "static-1.66078",
  "calling-internal-common": "static-1.31761",
  "calling-lifecycle-internal": "static-1.67460",
  "calling-lifecycle-messages": "static-1.59753",
  "conditional-properties-service-client": "static-1.4095",
  "crm-index-visualization-core": "static-1.4706",
  "crm-links": "static-1.6742",
  "crm-pipelines-api-client-types": "static-1.4427",
  "customer-data-objects-ui-components": "static-1.13465",
  "customer-data-properties-shared-msw-handlers": "static-1.10167",
  "customer-data-property-utils": "static-1.8483",
  "external-options-client-types": "static-1.4425",
  "formula-editor": "static-1.14957",
  "framework-data-schema-resolvers": "static-1.7330",
  "google-libphonenumber": "static-1.49",
  "hs-resources": "static-1.634",
  "inbound-db-meta-service-client": "static-1.3754",
  "inbounddb-objects-service-types": "static-1.4506",
  "meetings-icalendar-utils-lib": "static-1.1073",
  "multi-currency-client-types": "static-1.3991",
  "object-builder-ui-client": "static-1.49970",
  "pipeline-validation-client-types": "static-1.4264",
  "property-value-citations": "static-1.3556",
  "pulse": "static-1.1078",
  "smart-data-capture-core": "static-1.404",
  "smart-property-lib": "static-1.8562",
  "tiered-pricing": "static-1.2170",
  "topics-actions-lib": "static-1.614",
  "trellis-ext-i18n": "static-1.1327",
  "trial-components-library": "static-1.14317",
  "ui-addon-form-validation": "static-1.11342",
  "zustand": "static-1.88",
  "growth-onboarding-confetti": "static-1.3498",
  "growth-onboarding-next-action-utils": "static-1.2921",
  "navigation-components": "static-1.19093",
  "onboarding-tours-utils": "static-1.1408",
  "ui-shepherd-tracker": "static-1.8093",
  "ui-universal-auth": "static-1.9656",
  "getting-started-shared-tasks-store": "static-1.18615",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10838",
  "usage-tracker-session-replay": "static-1.5435",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1424",
  "tanstack-virtual": "static-1.42",
  "audio-components": "static-1.6515",
  "FileManagerCore": "static-1.40272",
  "FileManagerImages": "static-1.37924",
  "video-components": "static-1.14367",
  "foundations-components-legacy": "static-1.1710",
  "purchase-motions-api": "static-1.6588",
  "signup-constants": "static-1.19870",
  "signup-ui-url-generator": "static-2.8494",
  "stylex-utils": "static-1.168",
  "usage-tracker-public": "static-1.7560",
  "reactive-lib": "static-1.1160",
  "simple-logging-lib": "static-1.3489",
  "nudge-client-utils": "static-1.3355",
  "chatspot-core": "static-1.23616",
  "growth-onboarding-feedback-components": "static-1.7018",
  "cms-field-types": "static-1.5249",
  "content-icons-ui": "static-1.2420",
  "integrations-lib": "static-1.17333",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.1026",
  "breeze-engine-core": "static-1.1326",
  "ably": "static-2.2",
  "highlight.js": "static-1.90",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30730",
  "commerce-permissions": "static-1.1218",
  "customer-data-tracking": "static-1.7308",
  "products-iframe-lib": "static-1.8834",
  "products-ui-components-shared-msw-handlers": "static-1.11222",
  "restore-request-side-panel-lib": "static-1.1954",
  "onboarding-data-sync-lib": "static-1.2781",
  "hubspot-apollo-cache": "static-1.774",
  "calling-error-reporting": "static-1.31768",
  "shared-worker-versioning": "static-1.11478",
  "calling-usage-tracker": "static-1.6970",
  "voice-sms-access-library": "static-1.2359",
  "conversations-skeleton-state": "static-1.7603",
  "crm-index-associations-lib": "static-1.6885",
  "framework-data-schema-quick-fetch": "static-1.7235",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10923",
  "redux-toolkit": "static-1.82",
  "sales-views-client-types": "static-1.4693",
  "location-customization-utils-lib": "static-1.10353",
  "bark-lib": "static-1.16967",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6326",
  "react-codemirror": "static-1.11076",
  "fdsr-migration-layer": "static-1.449",
  "framework-builder-read-service-client": "static-1.4308",
  "persist-promise": "static-1.4141",
  "event-emitter": "static-1.1397",
  "bend-plugin-pulse": "static-1.581",
  "fast-json-patch": "static-1.74",
  "data-agent-kit": "static-1.843",
  "data-agent-test-utils": "static-1.387",
  "data-agent-utils": "static-1.856",
  "fsm": "static-1.4194",
  "policy-lib": "static-1.7245",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10986",
  "embedded-academy-lib": "static-1.15913",
  "hubs-service-types": "static-1.1701",
  "salesImages": "static-1.692",
  "growth-onboarding-next-action-components": "static-1.2949",
  "user-context-client": "static-1.4945",
  "nest": "static-1.671",
  "unified-auth-core-lib": "static-1.1452",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.765",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4951",
  "video-embed": "static-1.36857",
  "social-insights-client-types": "static-1.22871",
  "nudge-custom-function-registry": "static-1.3112",
  "nudge-renderer-utils": "static-1.3431",
  "whisper-core-api": "static-1.7576",
  "flux-actions": "static-1.380",
  "integrations-error-boundary-lib": "static-1.14748",
  "integrations-tracking-lib": "static-1.6050",
  "native-integrations-shared-strings": "static-1.8199",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10806",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1170",
  "InboxConnectUtils": "static-4.15780",
  "meetings-connect-utils-lib": "static-1.8053",
  "calling-orchestration-schema": "static-1.37136",
  "crm-record-cards-service-types": "static-1.3849",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16603",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.115",
  "trellis-story-utils": "static-1.4937",
  "enrichment-settings-lib": "static-1.174",
  "storybook-react": "static-1.44",
  "academy-common-lib": "static-1.15373",
  "outpost": "static-1.4569",
  "universal-page-editor-lib": "static-1.3444",
  "adobe-sign-auth-lib": "static-1.700",
  "ads-unified-auth-lib": "static-1.1829",
  "custom-vendor-connection-lib": "static-1.220",
  "google-sheets-integration-lib": "static-1.1266",
  "microsoft-drive-auth-lib": "static-1.426",
  "slack-ui-library": "static-1.10835",
  "surveymonkey-integration-lib": "static-1.795",
  "hub-http-contrib": "static-1.3465",
  "ui-addon-sales-email": "static-1.5639",
  "academy-service-client": "static-1.4128",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4830",
  "trellis-ecosystem": "static-1.7794",
  "wootric-nps": "static-1.7276",
  "marketplace-ui-apps-core": "static-1.19519",
  "marketplace-ui-common": "static-1.20987",
  "developer-experience-shared-components": "static-1.10975",
  "immutable-less": "static-1.5088",
  "marketplace-ui-client-types": "static-1.18394",
  "ui-addon-integrations-directory-panel": "static-2.8390",
  "ui-extensibility-client-types": "static-1.4352",
  "ai-settings-ui-library": "static-1.8523",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1484",
  "apps-service-types": "static-1.4083",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12966",
  "simple-data-table": "static-1.3762"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3335",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.507",
  "data-fetching-client": "/data-fetching-client/static-1.10079",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26434",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6028",
  "hs-test-utils": "/hs-test-utils/static-1.8473",
  "hub-http": "/hub-http/static-1.6645",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10840",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19215",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11929",
  "I18n": "/I18n/static-7.1700",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6886",
  "payment-link-components": "/payment-link-components/static-1.24376",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.26",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7615",
  "quartz-core": "/quartz-core/static-1.6834",
  "quartz-i18n": "/quartz-i18n/static-1.1290",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10648",
  "react-dlb": "/react-dlb/static-1.93",
  "react-utils": "/react-utils/static-2.5637",
  "reselect": "/reselect/static-3.16",
  "rich-text-lib": "/rich-text-lib/static-1.20494",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18526",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6066",
  "UIComponents": "/UIComponents/static-3.8875",
  "foundations-assets": "/foundations-assets/static-1.5322",
  "foundations-components": "/foundations-components/static-1.8685",
  "foundations-theming": "/foundations-theming/static-1.4922",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2638",
  "framer-motion": "/framer-motion/static-1.83",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1666",
  "quartz-config": "/quartz-config/static-1.1393",
  "quartz-routing": "/quartz-routing/static-1.1045",
  "quick-fetch": "/quick-fetch/static-1.4206",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-use-beacon-keepalive-queue.3",
  "rpc-client-utils": "/rpc-client-utils/static-1.5108",
  "sanitize-text": "/sanitize-text/static-1.8592",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.65",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5183",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9963",
  "usage-tracker": "/usage-tracker/static-1.7749",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6166",
  "usage-tracker-core": "/usage-tracker-core/static-1.7599",
  "video-components-external": "/video-components-external/static-1.12365",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3892",
  "quartz-webpack": "/quartz-webpack/static-1.3839",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.693",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.93",
  "customer-data-objects": "/customer-data-objects/static-1.8129",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8355",
  "laboratory-lib": "/laboratory-lib/static-3.7587",
  "onboarding-scopes": "/onboarding-scopes/static-1.6889",
  "seat-types-lib": "/seat-types-lib/static-1.979",
  "ui-addon-opt": "/ui-addon-opt/static-4.8822",
  "HeadJS": "/HeadJS/static-2.817",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3584",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.25",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.376",
  "ts-schema": "/ts-schema/static-1.4376",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8366",
  "content-media-capture": "/content-media-capture/static-1.5717",
  "cssUtils": "/cssUtils/static-1.1057",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10269",
  "file-manager-components": "/file-manager-components/static-1.24773",
  "HubStyle": "/HubStyle/static-2.12236",
  "knowledge-content-types": "/knowledge-content-types/static-1.8723",
  "PatternValidationJS": "/PatternValidationJS/static-1.3322",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.514",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10301",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11581",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9532",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10712",
  "video-data-lib": "/video-data-lib/static-1.36023",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4744",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6805",
  "customer-data-properties": "/customer-data-properties/static-1.52942",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19497",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5518",
  "onboarding-tours": "/onboarding-tours/static-1.17341",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8543",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3960",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9512",
  "user-context": "/user-context/static-1.5490",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.903",
  "hubspotter-http": "/hubspotter-http/static-1.4950",
  "icons": "/icons/static-2.700",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.601",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.601",
  "quartz-auth": "/quartz-auth/static-1.1290",
  "quartz-head": "/quartz-head/static-1.1280",
  "quartz-test": "/quartz-test/static-1.1290",
  "quartz-tracking": "/quartz-tracking/static-1.994",
  "trellis-components": "/trellis-components/static-1.3020",
  "ui-fonts": "/ui-fonts/static-1.1191",
  "usage-tracker-container": "/usage-tracker-container/static-1.7739",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9861",
  "data-token-picker": "/data-token-picker/static-1.17071",
  "FileManagerLib": "/FileManagerLib/static-1.40413",
  "property-translator": "/property-translator/static-1.5816",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6585",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6168",
  "react-create-root-preference": "/react-create-root-preference/static-1.97",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1270",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4954",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "trellis-assets": "/trellis-assets/static-1.3001",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3405",
  "foundations-theming-base": "/foundations-theming-base/static-1.3907",
  "stylex": "/stylex/static-1.46",
  "interframe": "/interframe/static-3.5177",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6163",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.226",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.137",
  "web-vitals": "/web-vitals/static-1.19",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.518",
  "chirp-fetch": "/chirp-fetch/static-1.2338",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4911",
  "react-flip-move": "/react-flip-move/static-1.82",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5023",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13521",
  "content-media-compositions": "/content-media-compositions/static-2.17528",
  "idb-keyval": "/idb-keyval/static-1.55",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4577",
  "magpie-lib": "/magpie-lib/static-1.5874",
  "magpie-types": "/magpie-types/static-1.5334",
  "media-bridge-lib": "/media-bridge-lib/static-1.19586",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4126",
  "superstore": "/superstore/static-1.5194",
  "feedback-loader": "/feedback-loader/static-1.30001",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9953",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9061",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29536",
  "ContentUtils": "/ContentUtils/static-1.69391",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4863",
  "sassPrefix": "/sassPrefix/static-1.325",
  "react-dnd-compat": "/react-dnd-compat/static-1.5046",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2048",
  "copilot-toolkit": "/copilot-toolkit/static-1.12079",
  "poll-commands": "/poll-commands/static-1.3911",
  "atom": "/atom/static-1.5513",
  "avatar-components": "/avatar-components/static-1.2921",
  "navigation-messaging": "/navigation-messaging/static-1.8420",
  "redux-thunk": "/redux-thunk/static-2.84",
  "reference-resolvers": "/reference-resolvers/static-1.8616",
  "commerce-products-lib": "/commerce-products-lib/static-1.10807",
  "crm-message-bus": "/crm-message-bus/static-1.44027",
  "growth-data-modal": "/growth-data-modal/static-1.6077",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5315",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5556",
  "batch-promise": "/batch-promise/static-1.1984",
  "calling-global-api": "/calling-global-api/static-1.66078",
  "calling-internal-common": "/calling-internal-common/static-1.31761",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67460",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59753",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4095",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4706",
  "crm-links": "/crm-links/static-1.6742",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4427",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13465",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10167",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8483",
  "external-options-client-types": "/external-options-client-types/static-1.4425",
  "formula-editor": "/formula-editor/static-1.14957",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7330",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "hs-resources": "/hs-resources/static-1.634",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3754",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4506",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1073",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3991",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49970",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4264",
  "property-value-citations": "/property-value-citations/static-1.3556",
  "pulse": "/pulse/static-1.1078",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.404",
  "smart-property-lib": "/smart-property-lib/static-1.8562",
  "tiered-pricing": "/tiered-pricing/static-1.2170",
  "topics-actions-lib": "/topics-actions-lib/static-1.614",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1327",
  "trial-components-library": "/trial-components-library/static-1.14317",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11342",
  "zustand": "/zustand/static-1.88",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3498",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2921",
  "navigation-components": "/navigation-components/static-1.19093",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1408",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8093",
  "ui-universal-auth": "/ui-universal-auth/static-1.9656",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18615",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10838",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5435",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1424",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "audio-components": "/audio-components/static-1.6515",
  "FileManagerCore": "/FileManagerCore/static-1.40272",
  "FileManagerImages": "/FileManagerImages/static-1.37924",
  "video-components": "/video-components/static-1.14367",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1710",
  "purchase-motions-api": "/purchase-motions-api/static-1.6588",
  "signup-constants": "/signup-constants/static-1.19870",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8494",
  "stylex-utils": "/stylex-utils/static-1.168",
  "usage-tracker-public": "/usage-tracker-public/static-1.7560",
  "reactive-lib": "/reactive-lib/static-1.1160",
  "simple-logging-lib": "/simple-logging-lib/static-1.3489",
  "nudge-client-utils": "/nudge-client-utils/static-1.3355",
  "chatspot-core": "/chatspot-core/static-1.23616",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7018",
  "cms-field-types": "/cms-field-types/static-1.5249",
  "content-icons-ui": "/content-icons-ui/static-1.2420",
  "integrations-lib": "/integrations-lib/static-1.17333",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1026",
  "breeze-engine-core": "/breeze-engine-core/static-1.1326",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.90",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30730",
  "commerce-permissions": "/commerce-permissions/static-1.1218",
  "customer-data-tracking": "/customer-data-tracking/static-1.7308",
  "products-iframe-lib": "/products-iframe-lib/static-1.8834",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11222",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1954",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2781",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.774",
  "calling-error-reporting": "/calling-error-reporting/static-1.31768",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11478",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6970",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2359",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7603",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6885",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7235",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10923",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "sales-views-client-types": "/sales-views-client-types/static-1.4693",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10353",
  "bark-lib": "/bark-lib/static-1.16967",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6326",
  "react-codemirror": "/react-codemirror/static-1.11076",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.449",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4308",
  "persist-promise": "/persist-promise/static-1.4141",
  "event-emitter": "/event-emitter/static-1.1397",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.581",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "data-agent-kit": "/data-agent-kit/static-1.843",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.387",
  "data-agent-utils": "/data-agent-utils/static-1.856",
  "fsm": "/fsm/static-1.4194",
  "policy-lib": "/policy-lib/static-1.7245",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10986",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15913",
  "hubs-service-types": "/hubs-service-types/static-1.1701",
  "salesImages": "/salesImages/static-1.692",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2949",
  "user-context-client": "/user-context-client/static-1.4945",
  "nest": "/nest/static-1.671",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1452",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.765",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4951",
  "video-embed": "/video-embed/static-1.36857",
  "social-insights-client-types": "/social-insights-client-types/static-1.22871",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3112",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3431",
  "whisper-core-api": "/whisper-core-api/static-1.7576",
  "flux-actions": "/flux-actions/static-1.380",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14748",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6050",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8199",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10806",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1170",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15780",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8053",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37136",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3849",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16603",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.115",
  "trellis-story-utils": "/trellis-story-utils/static-1.4937",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.174",
  "storybook-react": "/storybook-react/static-1.44",
  "academy-common-lib": "/academy-common-lib/static-1.15373",
  "outpost": "/outpost/static-1.4569",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3444",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.700",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1829",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.220",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1266",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.426",
  "slack-ui-library": "/slack-ui-library/static-1.10835",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.795",
  "hub-http-contrib": "/hub-http-contrib/static-1.3465",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5639",
  "academy-service-client": "/academy-service-client/static-1.4128",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4830",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7794",
  "wootric-nps": "/wootric-nps/static-1.7276",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19519",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20987",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10975",
  "immutable-less": "/immutable-less/static-1.5088",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18394",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8390",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4352",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8523",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1484",
  "apps-service-types": "/apps-service-types/static-1.4083",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12966",
  "simple-data-table": "/simple-data-table/static-1.3762"
}
};
